import { LoanEventType } from '@api';
import { PaginatedResponse, createDate } from '@tsp-ui/core';
import { rest } from 'msw';

import { getMockUrl } from '../../mocks/getMockUrl';

import { LoanActivity } from './loan-activity-api';


export const mocks = [
    rest.get(getMockUrl('/client/:clientId/loan-activity'), (req, res, ctx) => {
        const pageNumber = parseInt(req.url.searchParams.get('pageNumber') || '1', 10);
        const pageSize = parseInt(req.url.searchParams.get('pageSize') || '10', 10);

        const startIndex = (pageNumber - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize, allLoanActivities.length);
        const paginatedData = allLoanActivities.slice(startIndex, endIndex);

        return res(
            ctx.status(200),
            ctx.json({
                pageSize,
                pageNumber,
                totalPages: Math.ceil(allLoanActivities.length / pageSize),
                totalRecords: allLoanActivities.length,
                data: paginatedData
            } as PaginatedResponse<LoanActivity>)
        );
    }),
    rest.get(getMockUrl('/client/:clientId/customer/:customerId/loan-activity'), (req, res, ctx) => {
        const pageNumber = parseInt(req.url.searchParams.get('pageNumber') || '1', 10);
        const pageSize = parseInt(req.url.searchParams.get('pageSize') || '10', 10);

        const startIndex = (pageNumber - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize, allLoanActivities.length);
        const paginatedData = allLoanActivities.slice(startIndex, endIndex);

        return res(
            ctx.status(200),
            ctx.json({
                pageSize,
                pageNumber,
                totalPages: Math.ceil(allLoanActivities.length / pageSize),
                totalRecords: allLoanActivities.length,
                data: paginatedData
            })
        );
    })
];

const allLoanActivities: LoanActivity[] = [
    {
        id: '1',
        date: createDate(-.1).toISOString(),
        type: LoanEventType.VIEWED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '1',
        loanNumber: '7543683'
    },
    {
        id: '2',
        date: createDate(-.2).toISOString(),
        type: LoanEventType.UPDATED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '2',
        loanNumber: '7543684'
    },
    {
        id: '3',
        date: createDate(-.3).toISOString(),
        type: LoanEventType.CREATED,
        userId: '7245449-1697-4720-82b1-abf28594b063',
        loanId: '3',
        loanNumber: '7543685'
    },
    {
        id: '4',
        date: createDate(-.4).toISOString(),
        type: LoanEventType.INITIAL_DOC_PACKAGE_UPLOADED,
        userId: '23496874-1697-4720-82b1-f8dj48jf',
        loanId: '4',
        loanNumber: '7543686'
    },
    {
        id: '5',
        date: createDate(-.5).toISOString(),
        type: LoanEventType.PRICED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '5',
        loanNumber: '7543687'
    },
    {
        id: '6',
        date: createDate(-.6).toISOString(),
        type: LoanEventType.LOCKED,
        userId: '53630030-1697-4720-82b1-abf28594b063',
        loanId: '6',
        loanNumber: '7543688'
    },
    {
        id: '7',
        date: createDate(-.7).toISOString(),
        type: LoanEventType.COMMENT_CREATED,
        userId: '7245449-1697-4720-82b1-abf28594b063',
        loanId: '7',
        loanNumber: '7543689'
    },
    {
        id: '8',
        date: createDate(-.8).toISOString(),
        type: LoanEventType.DOCUMENT_UPLOADED,
        userId: '7245449-1697-4720-82b1-abf28594b063',
        loanId: '8',
        loanNumber: '7543690'
    },
    {
        id: '9',
        date: createDate(-.9).toISOString(),
        type: LoanEventType.LOAN_STATUS_UPDATED,
        userId: '7245449-1697-4720-82b1-abf28594b063',
        loanId: '9',
        loanNumber: '7543691'
    },
    {
        id: '10',
        date: createDate(-1.0).toISOString(),
        type: LoanEventType.UW_CONDITION_CREATED,
        userId: '53630030-1697-4720-82b1-abf28594b063',
        loanId: '10',
        loanNumber: '7543692'
    },
    {
        id: '11',
        date: createDate(-1.1).toISOString(),
        type: LoanEventType.UW_STEP_SUBMITTED,
        userId: '7245449-1697-4720-82b1-abf28594b063',
        loanId: '11',
        loanNumber: '7543693'
    },
    {
        id: '12',
        date: createDate(-1.2).toISOString(),
        type: LoanEventType.SETUP_COMPLETE,
        userId: '23496874-1697-4720-82b1-f8dj48jf',
        loanId: '12',
        loanNumber: '7543694'
    },
    {
        id: '13',
        date: createDate(-1.3).toISOString(),
        type: LoanEventType.REPRICED,
        userId: '23496874-1697-4720-82b1-f8dj48jf',
        loanId: '13',
        loanNumber: '7543695'
    },
    {
        id: '14',
        date: createDate(-1.4).toISOString(),
        type: LoanEventType.FLOATED,
        userId: '53630030-1697-4720-82b1-abf28594b063',
        loanId: '14',
        loanNumber: '7543696'
    },
    {
        id: '15',
        date: createDate(-1.5).toISOString(),
        type: LoanEventType.RELOCKED,
        userId: '7245449-1697-4720-82b1-abf28594b063',
        loanId: '15',
        loanNumber: '7543697'
    },
    {
        id: '16',
        date: createDate(-1.6).toISOString(),
        type: LoanEventType.COMMENT_UPDATED,
        userId: '23496874-1697-4720-82b1-f8dj48jf',
        loanId: '16',
        loanNumber: '7543698'
    },
    {
        id: '17',
        date: createDate(-1.7).toISOString(),
        type: LoanEventType.COMMENT_DELETED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '17',
        loanNumber: '7543699'
    },
    {
        id: '18',
        date: createDate(-1.8).toISOString(),
        type: LoanEventType.UW_CONDITION_UPDATED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '18',
        loanNumber: '7543700'
    },
    {
        id: '19',
        date: createDate(-1.9).toISOString(),
        type: LoanEventType.UW_CONDITION_COMMENT_CREATED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '19',
        loanNumber: '7543701'
    },
    {
        id: '20',
        date: createDate(-2.0).toISOString(),
        type: LoanEventType.UW_CONDITION_COMMENT_DELETED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '20',
        loanNumber: '7543702'
    },
    {
        id: '21',
        date: createDate(-2.1).toISOString(),
        type: LoanEventType.VIEWED,
        userId: '838170d6-76cf-45f2-92d0-70b2cf1a3304',
        loanId: '21',
        loanNumber: '7543703'
    },
    {
        id: '22',
        date: createDate(-2.2).toISOString(),
        type: LoanEventType.CREATED,
        userId: '53630030-1697-4720-82b1-abf28594b063',
        loanId: '22',
        loanNumber: '7543704'
    },
    {
        id: '23',
        date: createDate(-2.3).toISOString(),
        type: LoanEventType.LOCKED,
        userId: '7245449-1697-4720-82b1-abf28594b063',
        loanId: '23',
        loanNumber: '7543705'
    },
    {
        id: '24',
        date: createDate(-2.4).toISOString(),
        type: LoanEventType.DOCUMENT_UPLOADED,
        userId: '23496874-1697-4720-82b1-f8dj48jf',
        loanId: '24',
        loanNumber: '7543706'
    },
    {
        id: '25',
        date: createDate(-2.5).toISOString(),
        type: LoanEventType.SETUP_COMPLETE,
        userId: '23496874-1697-4720-82b1-f8dj48jf',
        loanId: '25',
        loanNumber: '7543707'
    }
];
